import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-brand-gray-dark rounded-2xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-start justify-between mb-12">
            <div className="flex items-center space-x-4">
              <img src="/icon.png" alt="Universal Pays Logo" className="w-12 h-12" />
              <h1 className="text-4xl font-bold gradient-text">Cookie Policy</h1>
            </div>
            <Link 
              to="/"
              className="text-gray-400 hover:text-brand-blue transition-colors duration-300 text-sm"
            >
              ← Back to Home
            </Link>
          </div>

          <div className="space-y-8">
            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">1. What are Cookies?</h2>
              <p className="text-gray-300">
                Cookies are small files that are stored on your device when you visit our website. They help us provide a better user experience and improve our services.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">2. Types of Cookies We Use</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-brand-blue pl-4">
                  <h3 className="text-xl font-semibold mb-2">Essential Cookies</h3>
                  <p className="text-gray-300">These cookies are necessary for the website to function properly.</p>
                </div>
                <div className="border-l-4 border-brand-blue pl-4">
                  <h3 className="text-xl font-semibold mb-2">Performance Cookies</h3>
                  <p className="text-gray-300">These cookies help us understand how visitors interact with our website.</p>
                </div>
                <div className="border-l-4 border-brand-blue pl-4">
                  <h3 className="text-xl font-semibold mb-2">Functionality Cookies</h3>
                  <p className="text-gray-300">These cookies remember your preferences to enhance your experience.</p>
                </div>
                <div className="border-l-4 border-brand-blue pl-4">
                  <h3 className="text-xl font-semibold mb-2">Targeting Cookies</h3>
                  <p className="text-gray-300">These cookies are used to deliver relevant advertising.</p>
                </div>
              </div>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">3. Managing Cookies</h2>
              <p className="text-gray-300 mb-4">
                You can manage your cookie preferences through your browser settings. Most browsers allow you to:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Block all cookies</li>
                <li>Allow only certain types of cookies</li>
                <li>Delete existing cookies</li>
                <li>View which cookies have been set</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">4. Third Party Cookies</h2>
              <p className="text-gray-300">
                Our website may use third-party services that set their own cookies. These include analytics services, social media platforms, and advertising networks.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">5. Cookie Consent</h2>
              <p className="text-gray-300">
                By using our website, you consent to our use of cookies as described in this policy. You can withdraw your consent at any time by managing your cookie preferences.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">6. Updates to Cookie Policy</h2>
              <p className="text-gray-300">
                We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">7. Contact Us</h2>
              <p className="text-gray-300">
                If you have any questions about this Cookie Policy, please contact us at:
                <br />
                Email: <a href="mailto:support@universalpays.com" className="text-brand-blue hover:underline">support@universalpays.com</a>
                <br />
                Phone: <a href="tel:+13658290725" className="text-brand-blue hover:underline">+13658290725</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
